module.exports = __webpack_public_path__ + "static/media/Legent_Virtual_Event.2ffd6b00.png";